<template>
  <div id="inner-screen">
    <p id="title">MECH PANEL</p>
    <svg
      class="ring-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
    >
      <path
        id="main-ring-svg"
        d="M 9 16 A 7 7 0 1 1 9 2 a 7 7 0 0 1 0 14 z m 0 1 A 8 8 0 1 0 9 1 a 8 8 0 0 0 0 16 z M 6.4 2.5 Q 7.5 3.5 7.5 4.5 Q 9 5 10.5 4.5 Q 10.5 3.5 11.6 2.5 Q 9 1.5 6.4 2.5 M 13.3 14.5 Q 13 12.9 12.2 12.4 Q 12.5 10.8 13.8 9.9 Q 14.5 10.4 15.9 10.1 Q 15.5 12.7 13.2 14.6 M 4.7 14.5 Q 5 12.9 5.8 12.4 Q 5.5 10.8 4.2 9.9 Q 3.5 10.3 2.1 10.1 Q 2.5 12.8 4.7 14.5"
      />
    </svg>
    <div class="inner-ring-svg">
      <!-- Donut SVG -->
      <svg
        class="inner-svg"
        id="donut-svg"
        style="top: 4.5%; left: 50%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          id="small-svg"
          d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
        />
      </svg>
      <svg
        class="inner-svg"
        id="donut-svg"
        style="top: 11%; left: 25%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          id="small-svg"
          d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
        />
      </svg>
      <svg
        class="inner-svg"
        id="donut-svg"
        style="top: 73%; left: 10%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          id="small-svg"
          d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
        />
      </svg>
      <svg
        class="inner-svg"
        id="donut-svg"
        style="top: 89%; left: 25%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          id="small-svg"
          d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
        />
      </svg>
      <svg
        class="inner-svg"
        id="donut-svg"
        style="top: 50%; left: 95.5%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          id="small-svg"
          d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
        />
      </svg>
      <svg
        class="inner-svg"
        id="donut-svg"
        style="top: 73%; left: 90%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          id="small-svg"
          d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
        />
      </svg>
      <svg
        class="inner-svg"
        id="donut-svg"
        style="top: 50%; left: -7.5%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
      >
        <path
          id="small-svg"
          d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
        />
      </svg>
      <p
        class="inner-svg"
        id="square-svg"
        style="top: 55%; left: -9%; background: none; border: none; font-size: 12.5px;"
      >
        SMD2
      </p>

      <!-- Square SVG -->
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 15%; left: 50%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 27%; left: 10%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 50%; left: 4.5%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 65%; left: 20%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 95.5%; left: 50%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 89%; left: 75%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 65%; left: 80%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 27%; left: 90%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 11%; left: 75%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <svg
        class="inner-svg"
        id="square-svg"
        style="top: 50%; left: 107.5%;"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
      >
        <path
          id="small-svg"
          d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
        />
      </svg>
      <p
        class="inner-svg"
        id="square-svg"
        style="top: 55%; left: 106%; background: none; border: none; font-size: 12.5px;"
      >
        SMD1
      </p>
    </div>
    <div class="left-panel">
      <p id="main-heading">ACCELERATION</p>
      <p id="sub-heading" style="top: 7.5%;">
        POSITIVE
        <svg
          class="inner-svg"
          id="square-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 15"
        >
          <path
            id="small-svg"
            d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 15%;">
        NEGATIVE
        <svg
          class="inner-svg"
          id="square-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 15"
        >
          <path
            id="small-svg"
            d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 22.5%;">
        ANGULAR
        <svg
          class="inner-svg"
          id="square-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 15"
        >
          <path
            id="small-svg"
            d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
          />
        </svg>
      </p>
      <p id="main-heading" style="top: 37.5%;">CENTRIPETAL</p>
      <p id="sub-heading" style="top: 45%;">
        ANTIGRAVITY
        <svg
          class="inner-svg"
          id="square-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 15"
        >
          <path
            id="small-svg"
            d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
          />
        </svg>
      </p>
      <p id="main-heading" style="top: 60%;">PRESSURE</p>
      <p id="sub-heading" style="top: 67.5%;">
        LQ OXYGEN
        <svg
          class="inner-svg"
          id="square-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 15"
        >
          <path
            id="small-svg"
            d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 75%;">
        LQ NITROGEN
        <svg
          class="inner-svg"
          id="square-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 15"
        >
          <path
            id="small-svg"
            d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 82.5%;">
        CO2 CANISTERS
        <svg
          class="inner-svg"
          id="square-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 15 15"
        >
          <path
            id="small-svg"
            d="M 5 5 C 5 4.6 10 4.6 10 5 C 10.5 5 10.5 10 10 10 C 10 10.5 5 10.5 5 10 C 4.6 10 4.5 5 5 5"
          />
        </svg>
      </p>
    </div>
    <div class="right-panel">
      <p id="main-heading">RESISTANCE</p>
      <p id="sub-heading" style="top: 7.5%;">
        TRUNKS SET:
        <svg
          class="inner-svg"
          id="donut-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            id="small-svg"
            d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 15%;">
        TRUNKS FIRED:
        <svg
          class="inner-svg"
          id="donut-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            id="small-svg"
            d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 22.5%;">
        DROGUES FIRED:
        <svg
          class="inner-svg"
          id="donut-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            id="small-svg"
            d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 30%;">
        MAINS FIRED:
        <svg
          class="inner-svg"
          id="donut-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            id="small-svg"
            d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 37.5%;">
        MAINS RELEASED:
        <svg
          class="inner-svg"
          id="donut-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            id="small-svg"
            d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
          />
        </svg>
      </p>

      <p id="main-heading" style="top: 60%;">WATER UPRIGHTING</p>
      <p id="sub-heading" style="top: 67.5%;">
        BALLAST PUMPS:
        <svg
          class="inner-svg"
          id="donut-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            id="small-svg"
            d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
          />
        </svg>
      </p>
      <p id="sub-heading" style="top: 75%;">
        BILGE PUMPS
        <svg
          class="inner-svg"
          id="donut-svg"
          style="top: 50%; left: 90%;"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
        >
          <path
            id="small-svg"
            d="M 7 12 A 5 5 0 1 1 7 2 a 5 5 0 0 1 0 10 z m 0 1 A 6 6 0 1 0 7 1 a 6 6 0 0 0 0 12 z"
          />
        </svg>
      </p>
    </div>
    <div class="bottom-panel" style="text-align: center;">
      <p id="main-heading" style="text-align:center; top: 0;">SEATS</p>
      <div class="inner-slot" id="IS1">
        <svg
          class="column-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="white"
          style="opacity: 0.5;"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"
          />
        </svg>
        <p id="column-sub-heading">SEAT 1 TACH</p>
        <p id="seven-number">
          {{ Math.round((this.randomNumber[0] + this.randomizer) * 100) / 100 }}
        </p>
        <p id="column-sub-unit">RPM / s</p>
      </div>
      <div class="inner-slot" id="IS2">
        <svg
          class="column-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="white"
          style="opacity: 0.5;"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"
          />
        </svg>
        <p id="column-sub-heading">SEAT 2 TACH</p>
        <p id="seven-number">
          {{ Math.round((this.randomNumber[1] + this.randomizer) * 100) / 100 }}
        </p>
        <p id="column-sub-unit">RPM / s</p>
      </div>
      <div class="inner-slot" id="IS3">
        <svg
          class="column-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="white"
          style="opacity: 0.5;"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"
          />
        </svg>
        <p id="column-sub-heading">SEAT 3 TACH</p>
        <p id="seven-number">
          {{ Math.round((this.randomNumber[2] + this.randomizer) * 100) / 100 }}
        </p>
        <p id="column-sub-unit">RPM / s</p>
      </div>
      <div class="inner-slot" id="IS4">
        <svg
          class="column-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="white"
          style="opacity: 0.5;"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"
          />
        </svg>
        <p id="column-sub-heading">SEAT 4 TACH</p>
        <p id="seven-number">
          {{ Math.round((this.randomNumber[3] + this.randomizer) * 100) / 100 }}
        </p>
        <p id="column-sub-unit">RPM / s</p>
      </div>
    </div>
    <div class="left-menu">
      <p id="left-heading" style="top:4%;">
        <svg
          class="left-menu-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="#ea7b15"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
          /></svg
        >ALL SYSTEMS CHECK<span style="top:100%;" id="left-sub-heading"
          >Awaiting</span
        >
      </p>
      <p id="left-heading" style="top:15%;">
        <svg
          class="left-menu-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="#ea7b15"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
          /></svg
        >ALL SYSTEMS CHECK<span style="top:100%;" id="left-sub-heading"
          >Awaiting</span
        >
      </p>
      <button
        v-bind:style="[
          activeButton
            ? ` background-color: white; color:#020738; border-radius: 10%; z-index:1;`
            : ` background-color: #020738; transform: scale(90%); color: white; border-radius: 10% 0 0 10%; z-index:0;`
        ]"
        @click="activeButton = !activeButton"
        style="left: 20%;"
      >
        SYSTEMS
      </button>
      <button
        v-bind:style="[
          !activeButton
            ? ` background-color: white; color:#020738; border-radius: 10%; z-index:1;`
            : ` background-color: #020738; transform: scale(90%); color: white; border-radius: 0 10% 10% 0; z-index:0;`
        ]"
        @click="activeButton = !activeButton"
        style="left: 47%;"
      >
        CABIN
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mech',
  props: [],
  data() {
    return {
      randomNumber: [79510.01, 71267.02, 73125.03, 75069.04, 71128.05],
      randomizer: 100.0,
      activeButton: true
    }
  },
  mounted() {
    this.animate()
  },
  methods: {
    animate() {
      setTimeout(this.animate, 1000)
      this.randomizer = Math.random() * 1000 - 500
    }
  }
}
</script>

<style scoped>
#inner-screen {
  overflow: hidden;
  position: absolute;
  background: #111b52;
  height: 91.5vh;
  width: 98.125vw;
  /* bottom: 30px; */
  top: 50%;
  left: 50%;
  /* bottom: 7em; */
  transform: translate(-50%, -50%);
  border-radius: 25px 25px 25px 25px;
  box-sizing: border-box;
  clip-path: polygon(
    0 0,
    0 100%,
    42.5% 100%,
    45% 95%,
    55% 95%,
    57.5% 100%,
    100% 100%,
    100% 0
  );
}

#inner-box-white {
  overflow: hidden;
  position: absolute;
  background: #111b52;
  background-position: center, center;
  height: 32%;
  width: 71%;
  /* bottom -15%; */
  top: 74.5%;
  left: 50%;
  /* bottom: 7em; */
  transform: translate(-50%, -50%);
  border-radius: 5px 5px 5px 5px;
  box-sizing: border-box;
  clip-path: polygon(
    40% 0,
    37.5% 10%,
    0.5% 10%,
    0.25% 10.5%,
    0 12%,
    0 100%,
    100% 100%,
    100% 12%,
    99.75% 10.5%,
    99.5% 10%,
    62.5% 10%,
    60% 0
  );
}

#inner-box {
  overflow: hidden;
  position: absolute;
  background: #020738;
  background-position: center, center;
  height: 30%;
  width: 70%;
  /* bottom: -15%; */
  top: 74.5%;
  left: 50%;
  /* bottom: 7em; */
  transform: translate(-50%, -50%);
  border-radius: 5px 5px 5px 5px;
  box-sizing: border-box;
  clip-path: polygon(
    45% 10%,
    42.5% 10%,
    0.5% 10%,
    0.25% 10.5%,
    0 12%,
    0 100%,
    100% 100%,
    100% 12%,
    99.75% 10.5%,
    99.5% 10%,
    57.5% 10%,
    55% 10%
  );
}

.ring-svg {
  position: absolute;
  width: max(27.5vw, 55vh);
  height: max(27.5vw, 55vh);
  /* border: 0.25px solid red; */
  top: 35%;
  left: 63%;
  transform: translate(-50%, -50%);
  /* padding: 10%; */
}

#main-ring-svg {
  stroke: rgba(255, 255, 255, 0.25);
  fill: rgba(255, 255, 255, 0.025);
  stroke-width: 0.025;
}

.inner-ring-svg {
  position: absolute;
  width: max(25vw, 50vh);
  height: max(25vw, 50vh);
  /* border: 0.25px solid green; */
  top: 35%;
  left: 63%;
  transform: translate(-50%, -50%);
}
.inner-svg {
  position: absolute;
  width: max(1.5vw, 3vh);
  height: max(1.5vw, 3vh);
  border: 0.25px solid rgba(255, 255, 255, 1);
  transform: translate(-50%, -50%);
  background: rgba(167, 185, 235, 0.25);
}

#small-svg {
  stroke: rgba(255, 255, 255, 1);
  fill: rgba(255, 255, 255, 1);
  stroke-width: 0.025;
}

.left-panel {
  position: absolute;
  width: 10%;
  height: 80%;
  /* border: 0.25px solid orange; */
  top: 50%;
  left: 35.5%;
  transform: translate(-50%, -50%);
}
.right-panel {
  position: absolute;
  width: 10%;
  height: 80%;
  /* border: 0.25px solid orange; */
  top: 50%;
  left: 90.5%;
  transform: translate(-50%, -50%);
}

.bottom-panel {
  position: absolute;
  width: 30%;
  height: 25%;
  /* border: 0.25px solid purple; */
  top: 80%;
  left: 63%;
  transform: translate(-50%, -50%);
}

.left-menu {
  position: absolute;
  width: 27.5%;
  height: 100%;
  /* border: 0.25px solid orange; */
  background: #020738;
  top: 50%;
  left: 13.5%;
  transform: translate(-50%, -50%);
}

.column-svg {
  position: absolute;
  width: max(1vw, 2.5vh);
  height: max(1vw, 2.5vh);
  top: 25%;
  transform: translate(-50%, -50%);
}

.left-menu-svg {
  position: absolute;
  width: max(1vw, 2vh);
  height: max(1vw, 2vh);
  left: -10%;
  transform: translate(-50%, -50%);
}

#column-sub-heading {
  position: absolute;
  width: 100%;
  /* height: 53%; */
  top: 35%;
  font-size: 0.55em;
  left: 50%;
  opacity: 0.5;
  transform: translate(-50%, -50%);
}

#column-sub-unit {
  position: absolute;
  width: 100%;
  /* height: 53%; */
  top: 75%;
  font-size: 0.5em;
  left: 50%;
  opacity: 0.5;
  transform: translate(-50%, -50%);
}

#left-sub-heading {
  position: absolute;
  width: 20%;
  padding-top: 0.5em;
  /* height: 53%; */
  /* top: 50%; */
  /* border: 1px solid white; */
  font-size: 1.05em;
  left: 0%;
  color: white;
  opacity: 1;
  /* transform: translate(-50%, -50%); */
}

#seven-number {
  position: absolute;
  width: 100%;
  /* height: 53%; */
  top: 50%;
  font-size: 1.25em;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
}

#sub-heading {
  position: absolute;
  width: 100%;
  /* height: 53%; */
  font-size: 0.75em;
  left: 50%;
  opacity: 0.5;
  transform: translate(-50%, -50%);
}

#main-heading {
  position: absolute;
  width: 100%;
  /* height: 53%; */
  font-size: 0.9em;
  left: 50%;
  transform: translate(-50%, -50%);
}
#left-heading {
  position: absolute;
  width: 50%;
  /* padding-left: 5%; */
  /* height: 53%; */
  font-size: 0.65em;
  left: 30%;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  opacity: 1;
  /* transform: translate(-50%, -50%); */
  /* border: 1px solid blue; */
}

#shadow {
  position: absolute;
  height: 100%;
  width: 100%;
  background: radial-gradient(
    35% 5% at 50% 92.5%,
    rgba(0, 0, 0, 0.45),
    rgba(0, 0, 0, 0)
  );
}

#heading {
  position: absolute;
  /* width: 20%; */
  /* height: 53%; */
  top: 4%;
  font-size: 1em;
  font-weight: 775;
  left: 50%;
  transform: translate(-50%, -50%);
}

#title {
  position: absolute;
  color: white;
  font-size: 1em;
  top: 0.5%;
  left: 50%;
  /* bottom: 7em; */
  transform: translate(-50%, -50%);
}

.inner-slot {
  position: absolute;
  height: 100%;
  width: 25%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

#IS1 {
  left: 12.5%;
}

#IS2 {
  left: 37.25%;
}

#IS3 {
  left: 62.5%;
}

#IS4 {
  left: 87.5%;
}

button {
  position: absolute;
  border: 1px solid white;
  text-align: center;
  width: 30%;
  height: 10%;
  bottom: 4%;
  /* top: 80%; */
  text-align: center;
  /* padding-bottom: 30%; */
  overflow: hidden;
  color: white;
}

svg {
  /* border: 1px solid tomato; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding-bottom: 0;
}
.arrows,
.zooms {
  fill: none;
  stroke: white;
  stroke-width: 1;
}
.white-svg {
  fill: white;
  stroke: white;
}

#box-title {
  position: absolute;
  color: white;
  font-size: 0.9em;
  font-weight: 750;
  top: 0%;
  left: 50%;
  /* bottom: 7em; */
  transform: translate(-50%, -50%);
}

#inner-slot-heading {
  position: relative;
  color: white;
  font-size: 0.7em;
  top: 10%;
}

#sound {
  position: relative;
  color: white;
  font-size: 5.25vw;
  /* font-weight: 700; */
  top: -7.5%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
